import Vue from 'vue'
import Vuetify from 'vuetify'
import VueNativeSock from 'vue-native-websocket'
import '../assets/css/ol.css';
import '../assets/css/olgm.css';
import '../assets/flags/flags.css';
import '../assets/fonts/Roboto/roboto.css';
import '../assets/fonts/Boon/boon.css';
import '../assets/fonts/MaterialDesignIcon/MaterialDesignIcon.css';
import '../assets/fonts/FontAwesome/font-awesome.css';
import '@mdi/font/css/materialdesignicons.css';
import 'vuetify/dist/vuetify.min.css';
import '../pages/app.css';

import colors from 'vuetify/es5/util/colors'

Vue.use(Vuetify, {
  theme: {
    primary: colors.green.base,
    secondary: colors.orange.accent1,
    accent: colors.green.accent4,
    error: colors.red.accent3,
    info: '#2196F3',
    success: '#4CAF50',
    warning: '#FFC107'
  }
});

//WebSocket is intented for signed-in users
//we do it after user has successfully logged
//therefore, the connect url will actually be change 
//at the time when this connect is about to connect.
Vue.use(VueNativeSock, 'ws://localhost:9090', {
  connectManually: true,
});

/*import Vue from 'vue'
import Vuetify from 'vuetify'
import 'vuetify/dist/vuetify.min.css'

Vue.use(Vuetify, {
  theme: {
    primary: '#ee44aa',
    secondary: '#424242',
    accent: '#82B1FF',
    error: '#FF5252',
    info: '#2196F3',
    success: '#4CAF50',
    warning: '#FFC107'
  },
})
shades.black,
    error: colors.red.accent3,
    info: '#2196F3',
    success: '#4CAF50',
    warning: '#FFC107'
  }
})*/